var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"outer",staticClass:"data-collection-progress"},[_c('div',{ref:"inner",staticClass:"data-collection-progress-inner"})])}
var staticRenderFns = []

export { render, staticRenderFns }